import { z } from 'zod';
export const stSummaryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        summary: z.object({
            disciplinesStillProvidingCare: z.array(z.string()).optional(),
            initialReasonHomeTherapy: z.string().optional(),
            reasonStillHomebound: z.string().optional(),
            impairmentsStillAddressed: z.array(z.string()).optional(),
            impairmentsStillAddressedOther: z.string().optional(),
        }),
        impairmentSummary: z.object({
            initial: z.string().optional(),
            current: z.string().optional(),
            goal: z.string().optional(),
        }),
        functionalSummary: z.object({
            initial: z.string().optional(),
            current: z.string().optional(),
            goal: z.string().optional(),
        }),
        outcomeMeasures: z.object({
            measure: z.array(z.string()).optional(),
            measureOther: z.string().optional(),
            initial: z.string().optional(),
            current: z.string().optional(),
            goal: z.string().optional(),
        }),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
